<template>
  <div>
    <layout-header></layout-header>
    <div class="layout-content">
      <div class="media-login-title">
        皇家加勒比集团媒体与新闻中心
      </div>
      <div class="media-login-main">
        <ul class="media-login-form">
          <li>
            <div class="label">手机</div>
            <div class="content">
              <input v-model="form.mobile" @input="onMobileChange($event)" class="mc-common-text" type="text" />
            </div>
          </li>
          <li>
            <div class="label">验证码</div>
            <div class="content">
              <input v-model="form.smsCode" class="mc-common-text" style="width: 152px;" type="text" />
              <!-- @click="sendSmsCode()" -->
              <button class="media-login-form-btn" id="sendCode" style="width: 116px;" >{{ getSendSmsCodeText() }}</button>
            </div>
          </li>
          <li>
            <div class="label">姓名</div>
            <div class="content">
              <input v-model="form.name" class="mc-common-text" type="text" :disabled="registered" />
            </div>
          </li>
          <li>
            <div class="label">媒体机构</div>
            <div class="content">
              <input v-model="form.organization" class="mc-common-text" type="text" :disabled="registered" />
            </div>
          </li>
          <li>
            <div class="label">职务</div>
            <div class="content">
              <input v-model="form.duty" class="mc-common-text" type="text" :disabled="registered" />
            </div>
          </li>
          <li>
            <div class="label">邮箱</div>
            <div class="content">
              <input v-model="form.email" class="mc-common-text" type="text" :disabled="registered" />
            </div>
          </li>
        </ul>
        <div class="media-login-btn">
          <button id="submitBtn" class="media-login-form-btn" @click="handleSubmit">点击登录/注册</button>
          <div v-if="!form.isExists" class="user-privacy-bar">
              <img id="userPrivacyChkPic" :src="isUserPrivacy ? chkBtnOnPic : chkBtnPic" @click="handleUserPrivacy"/>
              <span class="chk-txt">
                <span @click="handleUserPrivacy">我已经同意并阅读</span>
                <router-link to="/Rccl.UserCenter/Privacy" target="_blank">《用户隐私条款》</router-link>
              </span>
          </div>
        </div>
      </div>
    </div>
    <message-box v-if="verifyMsgShow" @close="verifyMsgShow=false">
      <template slot="context"><div v-html="verifyMsgText"></div></template>
    </message-box>

    <message-box v-if="registerSuccessMsgShow" @close="closeRegisterSuccessMsg">
      <template slot="context">感谢注册<br/>我们将尽快审核您的申请，<br/>并告诉您审核结果</template>
    </message-box>

    <message-box v-if="tipsShow" @close="tipsShow=false;tipsText=null">
      <template slot="context">{{tipsText}}</template>
    </message-box>
  </div>
</template>

<script>
import LayoutHeader from "../../layout/MediaCenter/components/LayoutHeader";
import { checkMail, checkTel} from '@/utilities/tools';
import api from "@/api";
import apiMc from "@/api/MediaCenter";
import MessageBox from "../../components/MediaCenter/MessageBox";

const FORM_DATA = {
  smsCode: null,
  name: null,
  organization: null,
  duty: null,
  email: null
}
export default {
  name: "MediaLogin",
  components: {MessageBox, LayoutHeader},
  data(){
    return {
      chkBtnPic: require('@/assets/MediaCenter/chk_btn.png'),
      chkBtnOnPic: require('@/assets/MediaCenter/chk_btn_on.png'),
      form: Object.assign({
        mobile: null
      },FORM_DATA),
      registered: false,
      isUserPrivacy: false,
      smsCodeCountDown: 0,
      isAllowLogin: true,
      sessionKey: null,
      verifyMsgShow: false,
      verifyMsgText: null,
      registerSuccessMsgShow: false,
      tipsShow: false,
      tipsText: null,
      captcha:null
    }
  },
  async beforeMount() {
    this.initAWSC()
  },
  methods: {
    handleUserPrivacy() {
      this.isUserPrivacy =! this.isUserPrivacy;
    },
    toUserPrivacy() {
      // window.location.href = "/wz_index_law/index";
      this.$router.push("/Rccl.UserCenter/Privacy");
    },
    async handleSubmit() {
      let isVerify = true;
      if (!this.form.mobile || !checkTel(this.form.mobile)) {
        isVerify = false;
      }
      if (!this.form.smsCode) {
        isVerify = false;
      }

      if(!this.form.isExists || this.form.isExists === 'undefined') {
        if (!this.form.name) {
          isVerify = false;
        }
        if (!this.form.organization) {
          isVerify = false;
        }
        if (!this.form.duty) {
          isVerify = false;
        }
        if (!this.form.email || !checkMail(this.form.email)) {
          isVerify = false;
          this.verifyMsgShow = true;
          this.verifyMsgText = `请填写正确的邮箱格式`;
          return;
        }
      }
      if(!isVerify){
        this.verifyMsgShow = true;
        this.verifyMsgText = `您还未注册申请<br/>请填写所有信息<br/>完成注册`;
        return;
      }
      if(!this.isUserPrivacy && !this.form.isExists) {
        this.verifyMsgShow = true;
        this.verifyMsgText = `请勾选用户隐私条款`;
        return;
      }

      const { success, data, errMsg } = await apiMc.newsFileList.login({
        mobile: this.form.mobile,
        name: this.form.name,
        organization: this.form.organization,
        duty: this.form.duty,
        email: this.form.email,
        sessionKey: this.sessionKey,
        smsCode: this.form.smsCode
      });
      if(success) {
        localStorage.setItem('dUserToken',data.token);
        if(this.registered) {
          this.registerJump();
        } else {
          this.registerSuccessMsgShow = true;
        }
      } else {
        this.openTips(errMsg);
      }
    },
    onMobileChange(e) {
      const mobile = e.target.value;
      this.form.telephone = mobile;
      if (this.form.mobile && checkTel(this.form.mobile)) {
        this.checkUser(mobile);
      }
    },
    async checkUser(mobile) {
      if (!this.isAllowLogin) return;
      const {success, data, errMsg} = await apiMc.newsFileList.checkUser(mobile);
      if(success) {
        if(data) {
          this.form = data;
          this.registered = true;
        } else {
          this.registered = false;
          this.form = Object.assign({
            mobile: this.form.mobile
          }, FORM_DATA);
          this.isUserPrivacy = false;
        }
      } else {
        console.log(errMsg);
      }
    },
    getInstance(instance) {
      this.captcha = instance
    },
    fail(error) {
      console.error(error);
      this.isAllowLogin = false
    },
    async success(captchaVerifyParam) {
      if (this.smsCodeCountDown > 0) {
        return;
      }
      console.log(captchaVerifyParam,'captchaVerifyParam');
      console.log(this.isAllowLogin,'this.isAllowLogin');
      this.isAllowLogin = true
      this.$loading.show();
			const request = this.getSmsRequest("AliYunAfsNc", captchaVerifyParam);
			await this.sendSmsApi(request);
    },
    initAWSC () {
      if (!window.initAliyunCaptcha) return
      // window.AWSC.use("nvc", (state, module) => {
      //   // 初始化 调用module.init进行初始化
      //   window.nvc = module.init({
      //     appkey: "FFFF0N00000000009D85",
      //     scene: "nvc_message_h5",
      //     renderTo:'#verificationMain',
      //     // test: module.TEST_NC_PASS,
      //     // 二次验证获取人机信息串，跟随业务请求一起上传至业务服务器，由业务服务器进行验签。
      //     success: async (data) => {
      //       this.$loading.show();
      //       const request = this.getSmsRequest("AliYunAfsNc", data);
      //       await this.sendSmsApi(request);
      //     },
      //     // 前端二次验证失败时触发该回调参数
      //     fail: (failCode) => {
      //       window.console && console.log(failCode);
      //       this.isAllowLogin = false
      //     },
      //     // 前端二次验证加载异常时触发该回调参数。
      //     error: (errorCode) => {
      //       window.console && console.log(errorCode);
      //       this.isAllowLogin = false;
      //     },
      //   });
      // });
      window.initAliyunCaptcha({
    // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      SceneId: "5v4v21th",
      // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
      mode: "popup",
      // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      element: "#verificationMain",
      // 触发验证码弹窗或无痕验证的元素
      button: "#sendCode",
      // 验证码验证通过回调函数
      success: this.success,
      // 验证码验证不通过回调函数
      fail: this.fail,
      // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
      getInstance: this.getInstance,
      // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。兼容历史参数名。
      slideStyle: {
        width: 260,
        height: 40,
      },
      // ...其他参数，参考initAliyunCaptcha参数说明
    });
    },
    async sendSmsCode() {
      if (this.smsCodeCountDown > 0 || !this.isAllowLogin) {
        return;
      }
      if (!this.form.mobile || !checkTel(this.form.mobile)) {
        this.openTips('请填写正确的手机号');
        return;
      }

      // 人机验证
      if (!window.nvc) return;
      this.$loading.show();
      window.nvc.getNVCValAsync(async (nvcVal) => {
        // 无痕验证获取nvc data，用无痕验证模式调用发送短信接口
        const request = this.getSmsRequest("AliYunAfsNvc", nvcVal);
        console.log(request)
        await this.sendSmsApi(request);
      });
    },
    getSmsRequest (codeType, codeValue) {
      // let callingCode = this.selectedCallingCode.callingCode;
      // if (
      //     callingCode &&
      //     callingCode.length > 1 &&
      //     callingCode.indexOf("+") == 0
      // ) {
      //   callingCode = callingCode.substring(1);
      // }
      return {
        phone: this.form.mobile,
        callingCode: '',
        sessionKey: this.sessionKey,
        codeType: codeType,
        codeValue: codeValue,
        sceneId: '5v4v21th',
				captchaVerifyParam: codeValue,
      };
    },
    // 无痕验证模式发送短信失败处理方法
    afsFailureHandler(code) {
      // 行为可疑，进入二次滑动验证
      if (code == 'NvcNc') {
        const ncoption = {
          renderTo: "#verificationMain",
        }
        let childNodes = document.getElementById('verificationMain').childNodes;
        for (let i = 0; i < childNodes.length; i++) {
          let childNode = childNodes[i];
          childNode.parentElement.removeChild(childNode);
        }
        // 唤醒二次验证（滑动验证码）
        this.isShowVerification = true;
        this.$nextTick(()=> {
          window.nvc.getNC(ncoption);
        })
      } else if (code == 'Block') {
        // 返回block，禁止发送短信
        this.isAllowLogin = false;
        this.openTips('网络错误，请刷新页面重试。');
      }
    },
    async sendSmsApi(request) {
      if (!this.isAllowLogin) return;
      const { success, data, errMsg } = await api.user.smsCodeLogin(request);
      this.$loading.hide();
      if (!success) {
        if (errMsg == 'NvcNc' || errMsg == 'Block') {
          // this.afsFailureHandler(errMsg)
        } else {
          this.openTips(errMsg);
          this.initAWSC()
        }
        return;
      } else {
          this.initAWSC()
        if (data && data.sessionKey) {
          this.sessionKey = data.sessionKey;
          //this.$store.commit("SET_SESSION_KEY", data.sessionKey);
        }
        this.isShowVerification = false;
        this.openTips("短信发送成功！若您没有收到短信验证，请一分钟后重新发送。");
      }
      this.smsCodeCountDown = 60;
      let countDown = setInterval(() => {
        if (this.smsCodeCountDown === 0) {
          clearInterval(countDown);
        } else {
          this.smsCodeCountDown--;
        }
      }, 1000);
    },
    getSendSmsCodeText() {
      if (this.smsCodeCountDown <= 0) {
        return "发送验证码";
      } else {
        return `验证码(${this.smsCodeCountDown}s)`;
      }
    },
    openTips(txt){
      this.tipsText = txt;
      this.tipsShow = true;
    },
    closeTips(){
      this.tipsShow = false;
      this.tipsText = null;
    },
    registerJump() {
      const redirectUrl = this.$router.currentRoute.query.redirectUrl;
      if (redirectUrl && redirectUrl.length > 0) {
        let path = decodeURIComponent(redirectUrl);
        this.$router.replace({path:path});
      } else {
        this.$router.replace({path:'/Rccl.CustomPage/MediaCenter/Index'});
      }
    },
    closeRegisterSuccessMsg() {
      this.registerSuccessMsgShow = false;
      this.registerJump();
    }
  }
}
</script>

<style lang="less" scoped>
input[type=button],input[type=text],input[type=password]{-webkit-appearance:none;outline:none;border-radius: 0;}
.layout-content {
  position: absolute;
  top: 65px;
  bottom: 0;
  left: 0;
  width: 100vw;
  padding: 0 0;
  overflow-x: hidden;
  overflow-y: auto;
}
/*媒体登录*/
.media-login-title {
  height: 74px;
  line-height: 74px;
  text-align: center;
  font-family: PingFangSC-Light, sans-serif;
  background-color: #00168b;
  color: #FFFFFF;
}
.media-login-main {
  width: 276px;
  padding: 29px 0;
  margin: 0 auto;
}
.media-login-form {
  & li {
    margin-top: 29px;
    &:first-child {
      margin-top: 0;
    }
    & .label {
      padding-bottom: 5px;
      font-family: PingFangSC-Light, sans-serif;
      color: #00116f;
    }
    & .content {
      display: flex;
      justify-content: space-between;
    }
  }
}
.media-login-form-btn {
  height: 37px;
  width: 274px;
  box-sizing:border-box;
  -moz-box-sizing:border-box;
  -webkit-box-sizing:border-box;
  border: 1px solid #d0b975;
  background-color: #d0b975;
  color: #FFFFFF;
}
.media-login-btn {
  margin-top: 29px;
  & .media-login-form-btn {
    height: 41px;
  }
}
.user-privacy-bar {
  margin-top: 15px;
  font-size: .6rem;
  font-family: PingFangSC-Light, sans-serif;
  color: #545a6f;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 14px;
  & .chk-btn {
    display: none;
    height: 14px;
    width: 14px;
  }
  & .chk-txt {
    line-height: 14px;
    margin-left: 5px;
    & a {
      text-decoration: underline;
      color: #00116f;
    }
  }
}
#verificationMain {
  width: 250px;
  margin: 10px auto 0;
  left: 50%;
  transform: translateX(-50%);
}
#verificationMain .nc_wrapper {
  width: 100% !important;
  margin: auto;
}
</style>
